var app = angular.module('leonardo');

var AppController = function (
  $scope,
  $rootScope,
  $state,
  $timeout,
  $window,
  ConfigThemeService,
  AuthDataService,
  AccountUserService,
  AuthService,
  PermissionService,
  FilterService,
  blockUI,
  deviceDetector,
  BrowserService,
  TemplateService,
  BrowserHistoryService,
  $element,
  $document,
  RestangularProvider,
  AnalyticsService
) {
  window.appController = $scope;

  // Ensure Segment is loaded
  if (!window.analytics) {
    console.error('[!] Segment Analytics not loaded');
  }
  else {
    AnalyticsService.track("Web Session Started");
  }

  RestangularProvider.all('get-theme')
    .customGET('', { noerror: true })
    .then(function (theme_config) {
      if (!isEmpty(theme_config)) {
        theme_config = compile_theme_config(theme_config);
        ConfigThemeService.updateConfig(theme_config);
        RestangularProvider.setBaseUrl(ConfigThemeService.config.url_config.api_url + '/api/2.0');
        $rootScope.$broadcast('white-label:update-theme');
      }
    });

  $scope.state = $state;
  $scope.actions = false;

  $scope.isNull = isNull;
  $scope.isEmpty = isEmpty;

  $scope.showActions = function () {
    $scope.actions = !$scope.actions;
  };

  $scope.actionsShow = function () {
    return $scope.actions;
  };

  $scope.contentActions = function () {
    return (
      $scope.state.current.views['actions@authenticated.layout-main'] &&
      Object.keys($scope.state.current.views['actions@authenticated.layout-main']).length > 0
    );
  };

  $scope.authDataService = AuthDataService;
  $scope.authService = AuthService;
  $scope.config = ConfigThemeService;
  $scope.isBeta = $scope.config.environment === 'beta';
  $scope.snapper = {};
  $scope.filterService = FilterService;
  $scope.templateService = TemplateService;
  $scope.browserService = BrowserService;
  $scope.permissionService = PermissionService;

  $scope.isPublic = function () {
    return $state.current.onboarding || $state.current.public;
  };

  if (_.contains(['ms-edge', 'ie'], deviceDetector.browser)) {
    $scope.isEdge = true;
  }

  $scope.initSnapper = function () {
    $scope.snapper = new Snap({
      element: angular.element('.snap-content')[0],
      maxPosition: 270,
      minPosition: -270,
      hyperextensible: false,
      touchToDrag: false
    });
  };

  $scope.openSnapper = function (side) {
    if ($scope.snapper.state().state !== 'closed') {
      $scope.snapper.close();
    } else {
      $scope.snapper.open(side);
    }
  };

  $scope.getClasses = function () {
    var classes = [];
    if ($state.current.public) {
      classes.push('public');
    }
    if ($state.current.onboarding) {
      classes.push('onboarding');
    }
    if ($state.current.cssClass) {
      classes.push($state.current.cssClass);
    }
    return classes;
  };

  $scope.getReportBreadcrumb = function () {
    var label_quick = 'Quick Reports List';
    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
      label_quick = 'System Quick Reports List';
    }
    return label_quick;
  };

  $scope.initLayout = function () {
    $timeout(function () {
      var logoHeight = angular.element('.wrapper-columns-column.region-left .zone-header').outerHeight();
      var userHeight = angular.element('.wrapper-columns-column.region-left .zone-user').outerHeight();
      var windowHeight = angular.element(window).height();
      var windowWidth = angular.element(window).width();
      var headerHeight = angular.element('.wrapper-columns-column.region-main .zone-header').outerHeight();
      
      // Check if running in iframe (embedded in React app)
      var isInIframe = false;
      try {
        isInIframe = window.self !== window.top;
      } catch (e) {
        // If we can't access window.top, we're definitely in a cross-origin iframe
        isInIframe = true;
      }
      
      angular.element('.wrapper-columns-column.region-left').css({ height: windowHeight });
      angular.element('.wrapper-columns-column.region-left .content-column').css({ height: windowHeight - logoHeight - userHeight });
      if (BrowserService.isMobile()) {
        headerHeight = angular.element('.snap-content .layout-main .zone-header').outerHeight();
        angular.element('.wrapper-columns-column.region-main .content-column').css({ width: windowWidth, height: windowHeight - headerHeight });
      } else {
        if (angular.element('.page-reports').length > 0) {
          angular
            .element('body.page-reports .layout-main .wrapper-columns-column.region-main')
            .css({ width: isInIframe ? windowWidth : windowWidth - 271, height: windowHeight });
        } else {
          angular
            .element('.wrapper-columns-column.region-main .content-column')
            .css({ width: isInIframe ? windowWidth : windowWidth - 270, height: windowHeight - headerHeight });
        }
      }
    }, 0);
  };

  blockUI.done(function () {
    BrowserHistoryService.init();
    $timeout(function () {
      $scope.initSnapper();
      $scope.initLayout();
    }, 0);
  });

  $scope.$on('init-snapper', function () {
    $timeout(function () {
      $scope.initSnapper();
      $scope.initLayout();
    }, 0);
  });

  $rootScope.$on('$locationChangeSuccess', function (ev, newUrl, oldUrl, newState, oldState) {
    var parentState = $state.current.name.split('.')[0];
    var pagePath = window.location.hash.replace('#', '');

    if (newUrl.includes('#ngdialog') || oldUrl.includes('#ngdialog')) {
      return;
    }

    switch (parentState) {
      case 'categories':
        pageCategory = 'Categories and Subcategories';
        break;
      case 'administrative-reports':
        pageCategory = 'Administrative Reports';
        break;
      case 'admin':
        pageCategory = 'Account management';
        break;
      case 'documents':
        pageCategory = 'Document Manager';
        break;
      case 'unit-turn':
        pageCategory = 'Unit Workflow';
        break;
      case 'portfolios':
        pageCategory = 'My portfolios';
        break;
      case 'approvals':
        pageCategory = 'My approvals';
        break;
      case 'client-instances':
      case 'my-white-label':
        pageCategory = 'Client Instances';
        break;
      case 'admin-utilities':
        pageCategory = 'Utilities';
        break;
      case 'sectors':
        pageCategory = 'Sectors and Fields';
        break;
      case 'login-redirection-work-as': 
        pageCategory = 'Work As Login Redirect';
        break;
      default:
        pageCategory =
          parentState && parentState.length > 0 ? parentState.charAt(0).toUpperCase() + parentState.slice(1) : $state.current.ncyBreadcrumbLabel;
    }
    
    trackPageView(newUrl, oldUrl, pagePath, pageCategory);

    function trackPageView(newUrl, oldUrl, pagePath, pageCategory) {
      if (!window.analytics) return;

      const skipTrackingPaths = ['/login-redirection'];
      if (skipTrackingPaths.includes(pagePath) || pagePath === '') {
        return;
      }

      analytics.page($state.current.title || $state.current.ncyBreadcrumbLabel || pageCategory, {
        path: pagePath,
        category: pageCategory,
        referrer: oldUrl,
        url: newUrl,
        title: $state.current.title || $state.current.ncyBreadcrumbLabel || "Home",
        ...AnalyticsService.getGlobalProperties()
      });
    }
    
    $timeout(function () {
      $scope.initSnapper();
      $scope.initLayout();
    }, 0);
  });

  angular.element($window).bind('resize', function () {
    $scope.initLayout();
  });

  $scope.$watch(
    function () {
      return angular.element('.wrapper-columns-column.region-main .zone-header').height();
    },
    function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.initLayout();
      }
    }
  );

  $scope.getCloseFn = function (scope) {
    if (!scope.$$childTail) return function () {
      // This is intentional do_something blank function
    };
    return scope.$$childTail.closeThisDialog || $scope.getCloseFn(scope.$$childTail);
  };

  $rootScope.$on('ngDialog.opened', function (e, $dialog) {
    var closeFn = $scope.getCloseFn(e.targetScope);
    BrowserHistoryService.register($dialog.attr('id'), closeFn);
    BrowserHistoryService.show($dialog.attr('id'));
    $timeout(function (){
      angular.element('.cloak-dialog').removeClass('cloak-dialog');
    }, 50)
  });

  $rootScope.$on('ngDialog.closing', function (e, $dialog) {
    if (BrowserHistoryService.existPopup($dialog.attr('id'))) {
      BrowserHistoryService.close(true);
      BrowserHistoryService.unregister($dialog.attr('id'));
    }
  });

  $scope.getColorHeader = function (isBeta) {
    if ($scope.isPublic()) {
      return ConfigThemeService.getColor('primaryColor');
    } else {
      return isBeta ? ConfigThemeService.getColor('$tertiaryColor', 0.2) : 'white';
    }
  };

  $rootScope.initLayout = $scope.initLayout;

  function compile_theme_config(theme_config) {
    return {
      name: theme_config.name,
      logo1: theme_config.principal_logo,
      logo2: theme_config.public_logo,
      logo3: theme_config.favicon_logo,
      url_config: {
        "api_url": theme_config.api_url,
        "web_url": theme_config.web_url,
        "media_url": theme_config.media_url
      },
      theme_config: {
        "auxColor": theme_config.aux_color,
        "errorColor": theme_config.error_color,
        "primaryColor": theme_config.primary_color,
        "successColor": theme_config.success_color,
        "warningColor": theme_config.warning_color,
        "tertiaryColor": theme_config.tertiary_color,
        "secondaryColor": theme_config.secondary_color
      }
    }
  }
};

app.controller('AppController', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$window',
  'ConfigThemeService',
  'AuthDataService',
  'AccountUserService',
  'AuthService',
  'PermissionService',
  'FilterService',
  'blockUI',
  'deviceDetector',
  'BrowserService',
  'TemplateService',
  'BrowserHistoryService',
  '$element',
  '$document',
  'Restangular',
  'AnalyticsService',
  AppController
]);
